import React, { useState } from 'react';
import './HostingLinux.css';

const HostingLinux = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'شخصی',
      price: '۱۲۰',
      unit: 'هزار تومان / ماه',
      disk: '۱۰ گیگابایت SSD',
      domains: '۱ دامنه',
      features: ['SSL رایگان', 'پشتیبانی ۲۴/۷', 'PHP 8.x', 'MySQL'],
      popular: false,
    },
    {
      tier: 'کسب‌وکار',
      price: '۲۵۰',
      unit: 'هزار تومان / ماه',
      disk: '۲۵ گیگابایت SSD',
      domains: '۵ دامنه',
      features: ['SSL رایگان', 'بکاپ روزانه', 'PHP 8.x', 'MySQL', 'پشتیبانی ۲۴/۷'],
      popular: true,
    },
    {
      tier: 'سازمانی',
      price: '۴۵۰',
      unit: 'هزار تومان / ماه',
      disk: '۵۰ گیگابایت SSD',
      domains: 'نامحدود دامنه',
      features: ['SSL Wildcard', 'بکاپ روزانه', 'PHP 8.x', 'MySQL', 'IP اختصاصی', 'اولویت پشتیبانی'],
      popular: false,
    },
  ];

  const features = [
    {
      icon: '🐧',
      title: 'سیستم‌عامل لینوکس با پایداری بالا',
      desc: 'استفاده از سیستم‌عامل لینوکس با پایداری فوق‌العاده و امنیت بالا. لینوکس محبوب‌ترین سیستم‌عامل برای میزبانی وب است و اکثر وب‌سایت‌های جهان روی آن اجرا می‌شوند.',
    },
    {
      icon: '💻',
      title: 'پشتیبانی از زبان‌های برنامه‌نویسی متنوع',
      desc: 'هاست لینوکس از زبان‌های برنامه‌نویسی PHP، Python، Node.js، Ruby، Perl و بسیاری دیگر پشتیبانی می‌کند. شما می‌توانید هر نوع اپلیکیشن وب را روی هاست لینوکس اجرا کنید.',
    },
    {
      icon: '🛡️',
      title: 'امنیت پیشرفته و به‌روزرسانی خودکار',
      desc: 'سرورهای لینوکس با به‌روزرسانی خودکار امنیتی و سیستم‌های حفاظتی پیشرفته، از وب‌سایت شما در برابر تهدیدات سایبری محافظت می‌کنند.',
    },
    {
      icon: '⚡',
      title: 'عملکرد بالا با سرورهای SSD',
      desc: 'استفاده از دیسک‌های SSD با سرعت بالا برای بارگذاری سریع‌تر وب‌سایت شما و بهبود تجربه کاربری.',
    },
  ];

  const faqs = [
    {
      q: 'هاست لینوکس برای چه نوع وب‌سایت‌هایی مناسب است؟',
      a: 'هاست لینوکس برای اکثر وب‌سایت‌ها از جمله وبلاگ‌ها، فروشگاه‌های آنلاین، وب‌سایت‌های شرکتی، اپلیکیشن‌های وب و پروژه‌های متنوع مناسب است. این نوع هاست با زبان‌های برنامه‌نویسی محبوب مانند PHP، Python و Node.js سازگار است و برای وب‌سایت‌های وردپرسی، جوملا، دروپال و بسیاری دیگر گزینه‌ای ایده‌آل محسوب می‌شود.',
    },
    {
      q: 'آیا هاست لینوکس برای مبتدیان مناسب است؟',
      a: 'بله، هاست لینوکس با کنترل پنل‌های کاربرپسند مانند cPanel یا DirectAdmin، برای مبتدیان نیز بسیار ساده و قابل استفاده است. شما می‌توانید بدون نیاز به دانش فنی خاص، وب‌سایت خود را مدیریت کنید، ایمیل بسازید و فایل‌ها را آپلود کنید. در صورت نیاز، تیم پشتیبانی افرسل نیز در تمام مراحل راهنمایی شما خواهد بود.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>هاست لینوکس | خرید هاست لینوکس با بهترین قیمت | افرسل</h1>
        <p>خرید هاست لینوکس با سرورهای SSD، پشتیبانی از PHP/Python/Node.js و پشتیبانی ۲۴ ساعته. هاست لینوکس مناسب برای وب‌سایت‌های وردپرسی، فروشگاه‌های آنلاین و اپلیکیشن‌های وب.</p>
        <meta name="description" content="خرید هاست لینوکس با بهترین قیمت از افرسل. هاست لینوکس با سرورهای SSD، پشتیبانی از PHP/Python/Node.js، SSL رایگان و پشتیبانی ۲۴/۷." />
      </div>

      <section className="hosting-linux-hero">
        <div className="hosting-linux-hero-bg"></div>
        <div className="wrap">
          <div className="hosting-linux-hero-content">
            <div className="hosting-linux-badge">
              <span className="pulse-dot"></span>
              🐧 هاست لینوکس
            </div>
            <h1 className="hosting-linux-hero-title">
              هاست <em>لینوکس</em>
            </h1>
            <p className="hosting-linux-hero-desc">
              هاست لینوکس با سرورهای SSD، پشتیبانی از زبان‌های برنامه‌نویسی متنوع و پشتیبانی ۲۴ ساعته.
              مناسب برای وب‌سایت‌های وردپرسی، فروشگاه‌های آنلاین و اپلیکیشن‌های وب.
            </p>
            <div className="hosting-linux-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">SSD</span>
                <span className="stat-label">دیسک پرسرعت</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hosting-linux-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های هاست لینوکس</span>
            <h2 className="sec-h">پلن <em>مناسب</em> وب‌سایت خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع هاست لینوکس با قیمت‌های رقابتی و منابع کافی برای هر نوع وب‌سایت.</p>
          </div>
          <div className="hosting-linux-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`hosting-linux-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="hosting-linux-popular-badge">پرفروش‌ترین</span>}
                <div className="hosting-linux-plan-tier">{plan.tier}</div>
                <div className="hosting-linux-plan-price">
                  <span className="hosting-linux-plan-num">{plan.price}</span>
                  <span className="hosting-linux-plan-unit">{plan.unit}</span>
                </div>
                <div className="hosting-linux-plan-specs">
                  <div><span>💾</span> {plan.disk}</div>
                  <div><span>🌐</span> {plan.domains}</div>
                </div>
                <ul className="hosting-linux-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="hosting-linux-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-linux-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای هاست لینوکس</span>
            <h2 className="sec-h">چرا <em>هاست لینوکس</em> با افرسل؟</h2>
            <p className="sec-p">هاست لینوکس با بهترین امکانات و خدمات برای توسعه‌دهندگان و کسب‌وکارها.</p>
          </div>
          <div className="hosting-linux-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="hosting-linux-feature-card">
                <span className="hosting-linux-feature-icon">{feature.icon}</span>
                <h3 className="hosting-linux-feature-title">{feature.title}</h3>
                <p className="hosting-linux-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-linux-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
          </div>
          <div className="hosting-linux-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="hosting-linux-faq-item">
                <div className="hosting-linux-faq-q">{faq.q}</div>
                <div className="hosting-linux-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-linux-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              هاست <em>لینوکس</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید هاست لینوکس، از سرعت بالا، پایداری عالی و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید هاست</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HostingLinux;
